module.exports = __webpack_public_path__ + "static/media/symbol.d8fdf437.svg";